import { useDispatch } from "react-redux";
import { useHistory } from "react-router";
import { TableCell, TableRow } from "@material-ui/core";
import moment from "moment";

import { blue500, gray800 } from "../../../uiKit/assets/colors/colors";
import { useStyle } from "../../../uiKit/CustomTable/customTable";
import Title from "../../../uiKit/Title/Title";

import { setTabType } from "../../../redux/state/communitySlice";

const RowRenderer = ({ items }) => {

    const cellClasses = useStyle();
    const history = useHistory();
    const dispatch = useDispatch();

    const navigateToDonationHandler = (campaign, communityId) => {

        if (!campaign) {
            history.push(`/communities/community/${communityId}`);
            dispatch(setTabType(4));
            return;
        }

        if (campaign.status === 'launched') {
            history.push(`/campaigns/campaign/active/${communityId}/${campaign.id}`);
            return;
        }

        if (campaign.status === 'completed' || campaign.status === 'stopped') {
            history.push(`/campaigns/campaign/completed/${communityId}/${campaign.id}`);
            return;
        }
    }

    return (
        items.map((item, index) => (
            <TableRow key={index}>
                <TableCell classes={cellClasses}>
                </TableCell>
                <TableCell classes={cellClasses} onClick={() => navigateToDonationHandler(item.to.campaign, item.to.community.id)} >
                    <Title
                        text={!!item.to.campaign ? item.to.campaign.name : 'Our balance'}
                        fontWeight={400}
                        color={blue500}
                        style={{
                            marginLeft: '20px',
                            marginRight: '8px',
                            cursor: 'pointer'
                        }} />
                </TableCell>
                <TableCell classes={cellClasses} onClick={() => navigateToDonationHandler(null, item.to.community.id)}>
                    <Title
                        text={item.to.community.name}
                        fontWeight={400}
                        color={blue500}
                        style={{ marginRight: '8px', cursor: 'pointer', }}
                    />
                </TableCell>
                <TableCell classes={cellClasses}>
                    <Title
                        text={`${moment(item.date).format('MM/DD/YYYY')} ${moment(item.date).format('h:mm A')}`}
                        fontWeight={400}
                        style={{ marginRight: '8px' }}
                        color={gray800}
                    />
                </TableCell>
                <TableCell classes={cellClasses}>
                    <Title
                        text={`$${item.amount.toLocaleString()}`}
                        fontWeight={400}
                        style={{ marginRight: '8px' }}
                        color={gray800}
                    />
                </TableCell>
            </TableRow>
        ))
    )
}

export default RowRenderer;